module.exports = "<svg id=\"79eca990-de2f-44f3-bf91-410714754adf\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>fb</title><rect width=\"50\" height=\"50\"></rect><path d=\"M28,43.34v-17h2c1.07,0,2.15,0,3.23,0a.64.64,0,0,0,.49-.34c.29-2.08.55-4.15.83-6.3H28.1c0-1.84-.1-3.61,0-5.36.1-1.25.84-1.84,2.12-2,1-.1,2-.09,3-.12h1.43V6.29c-.32,0-.63-.1-.95-.12-2.39-.11-4.8-.43-7.16.28a7.44,7.44,0,0,0-5.39,6.69c-.13,1.91-.1,3.82-.13,5.73,0,.24,0,.48,0,.79H15.41V26.3h5.64v17Z\" transform=\"translate(-0.07)\" style=\"fill: #fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fb.svg
// module id = 501
// module chunks = 1